import { CSSProperties, ReactNode } from "react";
import { Colors, Icon } from "main";

import styles from "./ErrorAlert.module.css";

type ErrorAlertProps = {
  customStyles?: CSSProperties;
  children: ReactNode;
};

export function ErrorAlert(props: ErrorAlertProps) {
  const { children, customStyles } = props;

  return (
    <div className={styles.errorBlock} style={customStyles}>
      <Icon name="Alert" color={Colors.red500} />
      {children}
    </div>
  );
}
